//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

module.exports = {
    actionElements: require('./actionElements'),
    dataViews: require('./dataViews'),
    detailPanes: require('./detailPanes'),
    filters: require('./filters'),
    formButtons: require('./formButtons'),
    formElements: require('./formElements'),
    forms: require('./forms'),
    listColumns: require('./listColumns'),
    lists: require('./lists'),
    navHeadings: require('./navHeadings'),
    searchElements: require('./searchElements'),
    workflowCriteriaElements: require('./workflowCriteriaElements'),
    workflowPanes: require('./workflowPanes'),
};


